import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Pagination, Navigation, FreeMode, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import Calendar from "./Calendar";
import PackageList from './PackageList';
import ProductSection from "../../components/Product/ProductSection";
import qr from '../../assets/img/qr.png';
import download from '../../assets/icon/down.svg';
import instance from "../../services/services";
import { LIKE_URL, DETAIL_PAGE_URL, RELATED_GOODS_URL, RECOMMEND_GOODS_URL, PACKAGE_GOODS_URL, MY_INFO_URL, STOCK_CALENDAR_URL } from "../../utils/urls";
import useUserStore from "../../store/userStore";
import { formatLocalString } from "../../utils/validation";
// import QRCode from "react-qr-code";
import CartConfirmPopup from "../../components/Popup/CartConfirmPopup";
import PackageReSelectPopup from "../../components/Popup/PackageReSelectPopup";
import orderApi from "../../services/Order/orderApi";
import PopupLoginError from "../../components/Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";
import rightIcon from '../../assets/icon/right_ic_arrow.png';
import ComponentViewPopup from "../../components/Popup/ComponentViewPopup";
import { INSTRUCTION_DATA_URL } from "../../utils/urls";

function PackageDetail() {
  const { t } = useLanguage();
  const navigation = useNavigate();
  const navigate = useNavigate();
  const { memberTokens, userInfo } = useUserStore();
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [myInfo, setMyInfo] = useState(null);
  const urlParts = window.location.pathname.split('/');
  const goods_seq = urlParts[urlParts.length - 1];
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSeeMore, setShowSeeMore] = useState(false);
  const descRef = useRef(null);
  const [state, setState] = useState({
    컷수: '',
    색상: '',
  });
  const [hoveredComponentIndex, setHoveredComponentIndex] = useState(null); 
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('outline');
  const [hoveredPackIndex, setHoveredPackIndex] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [isTablet, setIsTablet] = useState(window.innerWidth < 1280);
  const [detailData, setDetailData] = useState(null);
  const [relatedGoods, setRelatedGoods] = useState([]);
  const [recommendGoods, setRecommendGoods] = useState([]);
  const [isWish, setIsWish] = useState(!!detailData?.goods_like_seq);
  const [packageGoods, setPackageGoods] = useState([]); // 패키지 상품 데이터
  const [packTotal, setPackTotal] = useState(0);
  const [componentTotal, setComponentTotal] = useState([]); // 구성품 리스트
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [isPopupCart, setPopupCart] = useState(false);
  const [isPopupReSelect, setPopupReSelect] = useState({
    isOpen: false,
    packageData: [],
    selectedProductSeqs: [],
    totalCnt: 0
  });
  const [selectedProductInfo, setSelectedProductInfo] = useState([]);
  const [selectedProductSeqs, setSelectedProductSeqs] = useState([]);
  const [stockCalendar, setStockCalendar] = useState([]);
  const [instructionData, setInstructionData] = useState([]);  // 이용안내 데이터

  // 재고 달력 데이터 조회 - state로 변경
  const [currentYearMonth, setCurrentYearMonth] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  });
  const [isComponentPopup, setIsComponentPopup] = useState(false);

  // 월 변경 핸들러 추가
  const handleMonthChange = (newDate) => {
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const newYearMonth = `${year}-${month}`;
    setCurrentYearMonth(newYearMonth);
  };

  // 패키지, 단품 상세 > 주문방식
  const handleOrderMethod = (method) => {
    setState(prev => ({ ...prev, method }));
  };

  const handleTabActive = (tab) => {
    setActiveTab(tab);
  };

  // 좋아요 클릭
  const handleWish = async (e) => {
    e.stopPropagation();

    if (!memberTokens) {
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }

    try {
      const response = await instance.post(LIKE_URL, {
        goods_seq: goods_seq,
        member_seq: userInfo.member_seq
      });
      
      if (response.data.code === 200) {
        // detailData의 like_count를 숫자로 변환하여 계산
        const currentLikeCount = parseInt(detailData?.like_count || 0, 10);
        const newLikeCount = isWish ? currentLikeCount - 1 : currentLikeCount + 1;
        
        setIsWish(!isWish);
        
        // detailData 업데이트
        setDetailData(prev => ({
          ...prev,
          like_count: newLikeCount
        }));
      }
    } catch (error) {
      console.error('좋아요 API 호출 중 오류 발생:', error);
    }
  };

  // 상품 상세 데이터 조회
  useEffect(() => {
    const fetchDetailData = async () => {
      try {
        const response = await instance.post(DETAIL_PAGE_URL, {
          goods_seq: goods_seq,
          member_seq: userInfo.member_seq
        });
        setDetailData(response.data.data);
        if (response.data.data?.goods_like_seq) {
          setIsWish(true);
        }
        // setState(prev => ({
        //   ...prev,
        //   like_cnt: response.data.data?.like_count || 0
        // }));
      } catch (error) {
        console.error('상품 상세 데이터 가져오기 실패:', error);
      }
    };
    
    fetchDetailData();
  }, [goods_seq, userInfo.member_seq]);

  // 재고 달력 데이터 조회
  useEffect(() => {
    const fetchStockCalendar = async () => {
      if (!detailData?.goods_type) return; // detailData가 없으면 실행하지 않음
      
      try {
        const response = await instance.post(STOCK_CALENDAR_URL, {
          goods_seq: goods_seq, 
          goods_type: detailData?.goods_type,
          month: currentYearMonth,
          product_seq: selectedProductSeqs.length > 0 
            ? selectedProductSeqs 
            : (Array.isArray(detailData?.product_seq) 
                ? detailData?.product_seq 
                : [detailData?.product_seq])
        });
        
        setStockCalendar(response.data.data.goodsStock);
      } catch (error) {
        console.error('재고 달력 데이터 가져오기 실패:', error);
      }
    };
    
    // 패키지 타입이 아니거나, selectedProductSeqs가 설정된 후에만 호출
    if (detailData?.goods_type && 
        (detailData.goods_type !== 'package' || selectedProductSeqs.length > 0)) {
      fetchStockCalendar();
    }
  }, [goods_seq, detailData?.goods_type, selectedProductSeqs, currentYearMonth, detailData?.product_seq]);
  
  useEffect(() => {
    const fetchRelatedGoods = async () => {
      try {
        const response = await instance.post(RELATED_GOODS_URL, {
          goods_seq: goods_seq,
          member_seq: userInfo.member_seq,
          limit: 10,
        });
        setRelatedGoods(response.data.data.data);
      } catch (error) {
        console.error('관련 상품 데이터 가져오기 실패:', error);
      }
    };
    
    fetchRelatedGoods();
  }, [goods_seq, userInfo.member_seq]);

  // 추천 상품
  useEffect(() => {
    const fetchRecommendGoods = async () => {
      try {
        const response = await instance.post(RECOMMEND_GOODS_URL, {
          goods_seq: goods_seq,
          member_seq: userInfo.member_seq,
          limit: 10,
        });
        setRecommendGoods(response.data.data.data);
      } catch (error) {
        console.error('추천 상품 데이터 가져오기 실패:', error);
      }
    };
    
    fetchRecommendGoods();
  }, [goods_seq, userInfo.member_seq]);

  useEffect(() => {
    if (detailData) {
      // package나 rental이 아닐 경우 goods_type으로 설정
      if (detailData.goods_type !== 'package' && detailData.goods_type !== 'rental') {
        setState(prev => ({ ...prev, method: detailData.goods_type }));
      } else {
        // flag 값에 따라 초기 주문 방식 설정
        if (detailData.order_parcel_flag === 'Y' && detailData.order_visit_flag !== 'Y') {
          // 택배만 가능한 경우
          setState(prev => ({ ...prev, method: 'parcel' }));
        } else if (detailData.order_visit_flag === 'Y') {
          // 방문이 가능한 경우 (택배도 가능하더라도 방문을 우선)
          setState(prev => ({ ...prev, method: 'visit' }));
        } else {
          // 예외 처리
          setState(prev => ({ ...prev, method: '' }));
        }
      }
    }
  }, [detailData]);

  // 데이터가 로드될 때 각 옵션의 첫 번째 값을 선택함
  useEffect(() => {
    if (detailData?.goods_type === 'sale' && detailData?.goodsOption?.length > 0) {
      const initialOptions = {};
      
      // 각 옵션의 첫 번째 값을 선택
      detailData.goodsOption.forEach(option => {
        if (option.value && option.value.length > 0) {
          initialOptions[option.title.toLowerCase()] = option.value[0];
        }
      });
      
      // state 업데이트 (기존 state는 유지하면서 새 옵션만 추가)
      setState(prev => ({
        ...prev,
        ...initialOptions
      }));
    }
  }, [detailData]);

  // 팝업 확인 버튼 클릭 함수
  const handleConfirm = () => {
    if (isPopupLoginError.action === 'navigate_profile_edit') {
      navigate('/myPage/profile/edit');
    } else if (isPopupLoginError.action === 'navigate_login') {
      navigate('/login');
    }
    setIsPopupLoginError(false);
  };

  // 장바구니 확인 팝업
  const addCartProduct = async () => {
    // 로그인 상태 확인
    if (!memberTokens) {
      // 로그인이 안 되어있으면 로그인 팝업 표시
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }

    // 불량회원 체크
    if (myInfo === '불량회원') {
      setIsPopupLoginError({
        message: t('bad_member'),
        action: 'none'
      });
      return;
    }
    
    // 그룹 라벨 플래그가 Y인 경우 팝업 표시
    if (detailData?.group_label_flag === 'Y') {
      setIsPopupLoginError({
        message: "고객센터로 문의바랍니다.",
        action: 'none'
      });
      return;
    }

    // 패키지 타입인 경우, 선택된 상품이 없으면 재선택 팝업 열기
    if (detailData?.goods_type === 'package') {
      const hasSelectedProducts = selectedProductInfo.length > 0 || selectedPackages.length > 0;
      
      if (!hasSelectedProducts) {
        handleReSelectPackage();
        return;
      }
    }

    try {
      // 기본 요청 본문 구성
      const requestBody = {
        goods_seq: goods_seq,
        order_type: state.method === 'visit' || state.method === 'parcel' ? state.method : detailData?.goods_type,
        ea: 1,
        product_info: []
      };

      // 판매(sale) 타입인 경우에만 option_info 추가
      if (detailData?.goods_type === 'sale' && detailData?.goodsOption) {
        requestBody.option_info = detailData.goodsOption.map(option => ({
          title: option.title,
          option: state[option.title.toLowerCase()]
        }));
      }
      
      // 패키지 타입인 경우, 선택된 상품 정보 추가
      if (detailData?.goods_type === 'package') {
        // 재선택 팝업에서 선택된 정보가 있으면 그것을 사용, 없으면 기본 선택 사용
        if (selectedProductInfo.length > 0) {
          // 재선택 팝업에서 선택된 상품 정보 사용
          selectedProductInfo.forEach(item => {
            requestBody.product_info.push({
              product_seq: item.product_seq,
              product_kind: "main",
              ea: item.bundle_ea || 1
            });
          });
        } else {
          // 기본 선택된 패키지 항목들 사용
          packageGoods.forEach((item, index) => {
            if (selectedPackages.includes(index)) {
              requestBody.product_info.push({
                product_seq: item.product_seq, 
                product_kind: "main",
                ea: item.bundle_ea || 1
              });
            }
          });
        }
      } else {
        // 비패키지 타입의 기본 product_info
        requestBody.product_info = [
          {
            product_seq: "", 
            product_kind: "",
            ea: 0 
          }
        ];
      }

      const response = await orderApi.addToCart(
        requestBody.goods_seq,
        requestBody.order_type,
        requestBody.ea,
        requestBody.product_info,
        requestBody.option_info
      );

      if (response.data.code === 200) {
        setPopupCart(true); // 성공 시에만 팝업 열기
      } else {
        alert('장바구니 추가에 실패했습니다.');
      }
    } catch (error) {
      console.error('장바구니 추가 중 오류:', error);
      alert('장바구니 추가 중 오류가 발생했습니다.');
    }
  };

  // 패키지 재선택 팝업
  const handleReSelectPackage = () => {
    // 로그인 상태 확인
    if (!memberTokens) {
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }
    
    // 불량회원 체크
    if (myInfo === '불량회원') {
      setIsPopupLoginError({
        message: t('bad_member'),
        action: 'none'
      });
      return;
    }
    
    // 패키지 재선택용 데이터를 sort_num으로 정렬하여 가져오기
    const fetchPackageGoodsForReselect = async () => {
      try {
        const response = await instance.post(PACKAGE_GOODS_URL, {
          goods_seq: goods_seq,
          product_type: "main",
          limit: 24,
          offest: 1,
          order_by: "sort_num"  // 재선택 팝업에서는 sort_num으로 정렬
        });
        
        const reSelectData = response.data.data.data;
        
        setPopupReSelect({
          isOpen: true,
          packageData: reSelectData,  // sort_num으로 정렬된 데이터 사용
          selectedProductSeqs: selectedProductSeqs,
          totalCnt: response.data.data.cntRow  // totalCnt도 함께 저장
        });
      } catch (error) {
        console.error('패키지 재선택 데이터 가져오기 실패:', error);
      }
    };
    
    fetchPackageGoodsForReselect();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 패키지 상품 리스트
  useEffect(() => {    
    const fetchPackageGoods = async (page = 1) => {
      try {
        const response = await instance.post(PACKAGE_GOODS_URL, {
          goods_seq: goods_seq,
          product_type: "main",
          limit: 24,
          offest: page,
          order_by: "default_flag"  // 기본 화면에서는 default_flag로 정렬
        });
        
        // 상품 데이터 가져오기
        const newData = response.data.data.data;
        if (page === 1) {
          // default_flag=Y인 상품의 product_seq 찾기
          const defaultSelectedProductSeqs = newData
            .filter(item => item.default_flag === 'Y')
            .map(item => item.product_seq);
          
          // default_flag=Y인 상품 인덱스 찾기 (기존 로직 유지)
          const defaultSelectedIndexes = newData
            .map((item, index) => item.default_flag === 'Y' ? index : null)
            .filter(index => index !== null);
          
          // selectedPackages와 selectedProductSeqs 모두 업데이트
          setSelectedPackages(defaultSelectedIndexes);
          setSelectedProductSeqs(defaultSelectedProductSeqs);
          setPackageGoods(newData);
        } else {
          setPackageGoods(prev => [...prev, ...newData]);
        }
        
        setPackTotal(response.data.data.cntRow);
      } catch (error) {
        console.error('패키지 상품 데이터 가져오기 실패:', error);
      }
    };
    
    fetchPackageGoods(currentPage);
  }, [goods_seq, userInfo.member_seq, currentPage]);

  // 구성품 리스트
  useEffect(() => {    
    const fetchComponentGoods = async () => {
      try {
        const response = await instance.post(PACKAGE_GOODS_URL, {
          goods_seq: goods_seq,
          product_type: "cp",
          limit: 12,
          offest: 1
        });
        
        setComponentTotal(response.data.data.data);
      } catch (error) {
        console.error('패키지 상품 데이터 가져오기 실패:', error);
      }
    };
    
    fetchComponentGoods();
  }, [goods_seq, userInfo.member_seq, currentPage]);


  const sectionSwiperOptions = {
    slidesPerView: 2, // 모바일 기본값 2개
    spaceBetween: 8,
    autoHeight: false,
    pagination: { clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1280: { 
        slidesPerView: 5, 
        spaceBetween: 18,
        slidesPerGroup: 5 // PC에서는 5개씩
      },
      768: { 
        slidesPerView: 4, 
        spaceBetween: 12,
        slidesPerGroup: 4 // 태블릿에서는 4개씩
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 8,
        slidesPerGroup: 2 // 모바일에서는 2개씩
      },
      320: { // 더 작은 모바일 화면
        slidesPerView: 2,
        spaceBetween: 8,
        slidesPerGroup: 2
      }
    }
  };

  const packageSwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 8,
    pagination: { clickable: true, el: '.swiper-pagination' },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

  const mainSwiperOptions = {
    modules: [Thumbs, FreeMode, Pagination],
    thumbs: { swiper: thumbsSwiper },
    pagination: {
      enabled: true, 
      clickable: true,
      el: '.swiper-pagination'
    },
    breakpoints: {
      1280: { pagination: { enabled: false } }
    }
  };

  // 유튜브 주소 체크
  const convertYouTubeUrl = (url) => {
    if (!url) return '';
    
    let videoId;
    
    // youtu.be 형식 체크
    if (url.includes('youtu.be')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } 
    // youtube.com 형식 체크
    else if (url.includes('youtube.com')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    }
    
    if (!videoId) return '';
    
    return `https://www.youtube.com/embed/${videoId}`;
  };

  // 옵션 변경 핸들러
  const handleOptionChange = (optionType, value) => {
    setState(prev => ({
      ...prev,
      [optionType]: value
    }));
  };

  // 내정보 api
  useEffect(() => {
    const fetchMyInfo = async () => {
      try {
        const response = await instance.post(MY_INFO_URL);
        setMyInfo(response.data.data.mtype_name);
        
        // agree_flag가 'R'인 경우 팝업 표시
        if (response.data.data.agree_flag === 'R') {
          setIsPopupLoginError({
            message: t("authentication_info_expired"),
            action: 'navigate_profile_edit'
          });
        }
      } catch (error) {
        console.error('내정보 가져오기 실패:', error);
      }
    };
    
    if (memberTokens) {
      fetchMyInfo();
    }
  }, [memberTokens, t]);

  // 컴포넌트가 마운트될 때 body에 클래스 추가
  useEffect(() => {
    document.body.classList.add('hide-header-navi-mobile');
    
    // 컴포넌트가 언마운트될 때 클래스 제거
    return () => {
      document.body.classList.remove('hide-header-navi-mobile');
    };
  }, []);

  // 이미지 새창 열기 함수 수정 - 창에 40% 크기로 열기
  // const openImagePopup = (imageUrl) => {
  //   const screenWidth = window.innerWidth;
  //   const screenHeight = window.innerHeight;
  //   const popupWidth = Math.floor(screenWidth * 0.4);
  //   const popupHeight = Math.floor(screenHeight * 0.4);
  //   const left = Math.floor((screenWidth - popupWidth) / 2);
  //   const top = Math.floor((screenHeight - popupHeight) / 2);

  //   const popup = window.open(
  //     '', 
  //     'imagePopup', 
  //     `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,resizable=yes`
  //   );
    
  //   popup.document.write(`
  //     <!DOCTYPE html>
  //     <html>
  //       <head>
  //         <title>이미지 보기</title>
  //         <style>
  //           body {
  //             margin: 0;
  //             padding: 0;
  //             display: flex;
  //             justify-content: center;
  //             align-items: center;
  //             background-color: #000;
  //             min-height: 100vh;
  //             box-sizing: border-box;
  //             overflow: hidden;
  //           }
  //           img {
  //             width: 100vw;
  //             height: 100vh;
  //             object-fit: contain;
  //             background-color: #000;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <img src="${imageUrl}" alt="상세 이미지" onload="window.focus();" />
  //       </body>
  //     </html>
  //   `);
    
  //   popup.document.close();
  // };

  // 구성품 팝업 열기 함수
  const handleComponentPopup = () => {
    setIsComponentPopup(true);
  };

  // 네비게이션 버튼 동적 제어
  useEffect(() => {
    if (detailData?.goods_image) {
      const prevBtn = document.querySelector('.thumbnail-swiper-button-prev');
      const nextBtn = document.querySelector('.thumbnail-swiper-button-next');
      
      if (prevBtn && nextBtn) {
        const shouldShow = detailData.goods_image.length > 6;
        prevBtn.style.display = shouldShow ? 'block' : 'none';
        nextBtn.style.display = shouldShow ? 'block' : 'none';
      }
    }
  }, [detailData?.goods_image]);


  // 상품 설명 텍스트 줄바꿈 체크
  useEffect(() => {
    if (descRef.current) {
      const isClamped = descRef.current.scrollHeight > descRef.current.clientHeight;
      setShowSeeMore(isClamped);
    }
  }, [detailData?.description_kr_01]);

  // 말풍선 위치 계산 > 반응형고려
  const [deviceType, setDeviceType] = useState(
    window.innerWidth >= 1280 ? 'pc' : window.innerWidth >= 768 ? 'tablet' : 'mobile'
  );
  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1280) setDeviceType('pc');
      else if (window.innerWidth >= 768) setDeviceType('tablet');
      else setDeviceType('mobile');
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const bubblePosition = useMemo(() => {
    if (hoveredPackIndex === null) return null;
  
    const isFirstRow = Math.floor((hoveredPackIndex % 8) / 4) === 0;
    let top, left, transform;
  
    switch (deviceType) {
      case 'pc':
        top = isFirstRow ? '5px' : '70px';
        left = `${(hoveredPackIndex % 4) * 183 + 90}px`;
        transform = 'translateX(-50%)';
        break;
  
      case 'tablet':
        top = isFirstRow ? '0px' : '60px';
        left = `${(hoveredPackIndex % 4) * 280 + 40}px`;
        transform = 'translateX(-10%)';
        break;
  
      case 'mobile': {
        // 📱 모바일은 4행 2열 구조
        const row = Math.floor((hoveredPackIndex % 8) / 2); // 0~3 행
        const col = hoveredPackIndex % 2; // 0 or 1
  
        // ✅ 600px 기준 분기 추가
        if (window.innerWidth <= 600) {
          // 🔹 작은 모바일 (예: iPhone SE, Galaxy S 등)
          top = `${row * 64 + 5}px`;
          left = `${col * 150 + 65}px`; // 좁은 화면이라 x축 좁힘
          transform = 'translateX(-40%)';
        } else {
          // 🔹 일반 모바일 (예: iPhone 13, Galaxy S24)
          top = `${row * 68 + 5}px`;
          left = `${col * 320 + 75}px`;
          transform = 'translateX(-20%)';
        }
        break;
      }
  
      default:
        top = '0px';
        left = '0px';
        transform = 'none';
    }
  
    return { top, left, transform };
  }, [hoveredPackIndex, deviceType]);
  
  // 이용안내 데이터 가져오기
  useEffect(()=> {
    const fetchInstructionData = async () => {
      try {
        const response = await instance.post(INSTRUCTION_DATA_URL);
        setInstructionData(response.data.data.data);
      } catch (error) {
        console.error('이용안내 데이터 가져오기 실패:', error); 
      }
    };
    fetchInstructionData();
  }, []);

  return (
    <div className="detail_page_default">
      {/* 모바일에서 헤더 네비게이션만 숨기기 위한 스타일 */}
      <style jsx="true">{`
        @media screen and (max-width: 1279px) {
          body.hide-header-navi-mobile .header_navi {
            display: none !important;
          }
        }
      `}</style>

      <section className="detail_container">
        <div className="d_inner">
          <div className="detail_left">
            <div style={{position:'relative'}}> 
              <div className="border-text-box">{detailData?.goods_code}</div>
              <Swiper {...mainSwiperOptions} className="main_swiper">
                {detailData?.goods_image.map((image, idx) => (
                  <SwiperSlide key={`main_${idx}`}>
                    <div className="default_prod_detail prod_item">
                      <div className="brand_img_main">
                        <img src={image?.brand} alt="brand_img" loading="lazy"/>
                      </div>
                      <div className="detail_img_main">
                        <img src={image?.goods} alt="detail_img"/>
                      </div>
                      {/* 특별문구 */}
                      {detailData?.summary_flag === 'Y' && (
                        <div 
                          className="summary_badge"
                          style={{
                            backgroundColor: detailData?.summary_bg_color,
                            color: detailData?.summary_txt_color,
                            border: `1px solid ${detailData?.summary_border_color}`
                          }}
                        >
                          {detailData?.summary_txt}
                        </div>
                      )}
                      {/* 뱃지 */}
                      <div className="badge_container">
                        <p className="detal_prod_type flex-center">
                          {detailData?.badgeList?.map((badge, index) => (
                            <span 
                              key={index} 
                              className="badge_item"
                              style={{
                                backgroundColor: badge.badge_color_bg,
                                color: badge.badge_color_txt,
                                border: `1px solid ${badge.badge_color_border || badge.badge_color_bg}`
                              }}
                            >
                              {badge.badge_name}
                            </span>
                          ))}
                        </p>
                      </div>

                      <div className="qr">
                        {detailData?.qrcode_url ? (
                          // <QRCode 
                          //   value={detailData.qrcode_url} 
                          //   size={66} 
                          //   level="H"
                          //   style={{ backgroundColor: 'white' }}
                          // />
                          <img src={detailData.qrcode_url} alt="qr" ></img>
                        ) : (
                          <img src={qr} alt="qr"/> 
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                <div className="swiper-pagination"></div>
              </Swiper>

              {!isTablet && (
                <div style={{
                  position: 'relative', 
                  // padding: '0 16px', 
                  width: '615px'
                }}>
                  {/* 좌측 화살표 */}
                  {detailData?.goods_image && detailData.goods_image.length > 6 && (
                    <div 
                      className="thumbnail-swiper-button-prev swiper-button-prev"
                      style={{ 
                        position: 'absolute',
                        top: '81%',
                        left: '-11px',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        color: '#333',
                        '--swiper-navigation-color': '#333',
                        '--swiper-theme-color': '#333',
                      }}
                    />
                  )}

                  {/* Swiper 자체 */}
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={2}
                    slidesPerView="auto"
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Thumbs, Navigation]} 
                    allowTouchMove={true}
                    touchRatio={1}
                    touchAngle={45}
                    className="thumbnail_swiper"
                    // 네비게이션 설정을 조건부로 적용
                    navigation={detailData?.goods_image && detailData.goods_image.length > 6 ? {
                      nextEl: '.thumbnail-swiper-button-next',
                      prevEl: '.thumbnail-swiper-button-prev',
                    } : false}
                  >
                    {detailData?.goods_image.map((image, idx) => (
                      <SwiperSlide key={`thumb_${idx}`}>
                        <div className="sub_prod">
                          <div className="brand_img_sub">
                            <img src={image.brand_thumb} alt="brand_img" loading="lazy"/>
                          </div>
                          <div className="detail_img_sub">
                            <img src={image.goods_thumb} alt="detail_img" loading="lazy"/>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* 우측 화살표 */}
                  {detailData?.goods_image && detailData.goods_image.length > 6 && (
                    <div 
                      className="thumbnail-swiper-button-next swiper-button-next"
                      style={{ 
                        position: 'absolute',
                        top: '81%',
                        right: '-4px',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        color: '#333',
                        '--swiper-navigation-color': '#333',
                        '--swiper-theme-color': '#333'
                      }}
                    />
                  )}
                </div>
              )}
            </div>

            {detailData?.goods_type === "package" && detailData?.description_file && (
              <div>
                  <a href={detailData?.description_file} target="_blank" rel="noopener noreferrer">
                    <div className="product_desc">
                        <span style={{cursor:'pointer'}}>{t('product_description')}</span>
                        <span className="download">
                          <img src={download} alt="description" loading="lazy"/>
                        </span>
                    </div>
                  </a>
              </div>
            )}

            {(detailData?.goods_type === "rental" || detailData?.goods_type === "sale") && ( 
              <div className="detail_grid_con">
                {/* 구성품 리스트 */}
                
                {/* PC에서 보이는 부분 */}
                {!isTablet && (
                  <div className="flex-btw">
                    {/* 구성품 리스트 타이틀 */}
                    {componentTotal.length > 0 && (
                      <div className="p2">
                        <h3><span className="d_yellow_text">{t('default')}</span>{t('components')}</h3>
                      </div>
                    )}

                    {/* 상품 설명서 */}
                    {detailData?.description_file && (
                    <a href={detailData?.description_file} target="_blank" rel="noopener noreferrer">
                      <div className="product_desc">
                          <span style={{cursor:'pointer'}}>{t('product_description')}</span>
                          <span className="download">
                            <img src={download} alt="description" loading="lazy"/>
                          </span>
                      </div>
                    </a>
                    )}
                  </div>
                )}

                {/* 모바일에서 보이는 부분 */}
                
                {isTablet && (
                  <div className="flex-btw" style={{cursor:'pointer', justifyContent:'normal', gap: '4px'}}>
                    {componentTotal.length > 0 && (
                    <div 
                      className="component_title"
                      onClick={handleComponentPopup}
                    >
                      기본 구성품 보기 <img src={rightIcon} alt="right" loading="lazy"/>
                    </div>
                    )}
                    
                    {/* 상품 설명서 */}
                    {detailData?.description_file && (
                    <a href={detailData?.description_file} target="_blank" rel="noopener noreferrer">
                      <div className="product_desc">
                          <span style={{cursor:'pointer'}}>{t('product_description')}</span>
                          <span className="download">
                            <img src={download} alt="description" loading="lazy"/>
                          </span>
                      </div>
                    </a>
                    )}
                  </div>
                )}

                {/* PC에서만 보이는 구성품 리스트 이미지 */}
                {/* {!isTablet && (
                  <div className="grid_prod">
                    {componentTotal.map((image, index) => (
                    <div 
                      className="detail_img_sub" 
                      key={index}
                      // onClick={() => openImagePopup(image.goods_image[0])}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={image.goods_image[0]} alt="detail_img" loading="lazy"/>
                      <span className="goods_thumb_num">x8</span>

                    </div>
                    ))}
                  </div>
                )} */}
                {!isTablet && (
                  <div className="grid_prod" style={{position:'relative'}}>
                    {componentTotal.map((image, index) => (
                      <div 
                        className="detail_img_sub" 
                        key={index}
                        onMouseEnter={() => setHoveredComponentIndex(index)}
                        onMouseLeave={() => setHoveredComponentIndex(null)}
                        style={{ cursor: 'pointer', position:'relative' }}
                      >
                        <img src={image.goods_image[0]} alt="detail_img" loading="lazy"/>
                        <span className="goods_thumb_num">x{image?.bundle_ea}</span>

                        {/* 말풍선 */}
                        {hoveredComponentIndex === index && (
                          <div 
                            className="price_bubble goods_thumb_bubble"
                            style={{
                              position: 'absolute',
                              top: '-90px',
                              left: '50%',
                              transform: 'translateX(-60%)',
                              zIndex: 9999
                            }}
                          >
                            <p className="goods_thumb_name">상품명 : {image?.product_name}</p>
                            <span className="goods_num">x{image?.bundle_ea}</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

              </div>
            )}
          </div> 

          <div className="detail_right">
            <div>
              <div className="detail_title ">
                <h2 className="ellipsis_clamp">{detailData?.goods_name || '상품명 없음'}</h2>
                <p className="ellipsis1">{detailData?.goods_name02 || ''}</p>
              </div>

              {/* 상품 설명 */}
              {/* {detailData?.description_kr_01 && (
              <div className="detail_title_desc" style={{marginTop:'12px'}}>
                <p className={isExpanded ? 'expanded' : ''}>
                  {detailData?.description_kr_01 || '상품설명 없음'}
                </p> */}
                {/* detailData?.description_kr_01의 글자수가 50자 제한 */}
                {/* {!isExpanded && detailData?.description_kr_01.length > 50 && (
                  <button className="txt_more" onClick={() => setIsExpanded(true)}>{t('see_more')}</button>
                )}

              </div>
              )} */}
              
              {/* 상품 설명 */}
              <div className="detail_title_desc" style={{ marginTop: "12px" }}>
                <p
                  ref={descRef}
                  className={isExpanded ? "expanded" : ""}
                >
                  {detailData?.description_kr_01 || "상품설명 없음"}
                </p>

                {/* 잘렸을 때만 see_more 버튼 보이기 */}
                {!isExpanded && showSeeMore && (
                  <button className="txt_more" onClick={() => setIsExpanded(true)}>
                    {t('see_more')}
                  </button>
                )}
              </div>

            </div>

            {(detailData?.goods_type === 'package' || detailData?.goods_type === 'rental') && (
              <div>
                <div className="order_method flex-12 column">
                  <div className="select_method flex-center">
                    <div className="selected flex-center-4">
                      {t('order_method_selection_txt')}:
                      <span>
                        {state.method === 'visit' ? t('visit') : 
                        state.method === 'parcel' ? t('delivery') : ''}
                      </span>
                    </div>
                  </div>

                  <div className="btn_box flex-center-8">
                    {detailData?.order_visit_flag === 'Y' && (
                      <div
                        className={`order_m_btn ${state.method === 'visit' ? 'active' : ''}`}
                        onClick={() => handleOrderMethod('visit')}
                      >
                        <span className={`ic_14 order_visit ${state.method === 'visit' ? 'active' : ''}`}></span>
                        <span>{t('visit')}</span>
                      </div>
                    )}
                    {detailData?.order_parcel_flag === 'Y' && (
                      <div
                        className={`order_m_btn ${state.method === 'parcel' ? 'active' : ''}`}
                        onClick={() => handleOrderMethod('parcel')}
                      >
                        <span className={`ic_14 order_parcel ${state.method === 'parcel' ? 'active' : ''}`}></span>
                        <span>{t('delivery')}</span>
                      </div>
                    )}
                  </div>
                  {/* <div className="flex-center-8">
                    <div className="detail_deposit">
                      {t('deposit')}: <span style={{fontSize:'12px', color: '#7A7A7A'}}>₩</span><span style={{color: '#7A7A7A'}}>{formatLocalString(detailData?.deposit_price || 0)}</span>
                    </div>
                    <div className="detail_insurance">
                      {t('peace_of_mind_insurance')}: <span style={{color: '#7A7A7A'}}>{detailData?.insurance_flag === "Y" ? t('possible_to_join') : t('impossible_to_join')}</span>
                    </div>
                  </div> */}
                </div>
              </div>
            )}

            {detailData?.goods_type === 'sale' && 
              detailData.goodsOption.map((option, idx) => (
                <div className="detail_sale_con" key={idx}>
                  <div>
                    <div className="order_method flex-12 column">
                      <div className="select_method flex-center">
                        <div className="selected flex-center-4">
                          {option.title}:
                          <span>
                            {state[option.title.toLowerCase()] || ''}
                          </span>
                        </div>
                      </div>

                      <div className="btn_box flex-center-8">
                        {option.value.map((val, valIdx) => (
                          <div
                            key={valIdx}
                            className={`order_m_btn ${state[option.title.toLowerCase()] === val ? 'active' : ''}`}
                            onClick={() => handleOptionChange(option.title.toLowerCase(), val)}
                          >
                            <span>{val}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div>
              
              <div className="prod_price_detail" style={{ position: 'relative' }}>

                <div className="flex-center-8" style={{marginTop:'16px'}}>
                  <div className="detail_deposit">
                    {t('deposit')}: <span style={{fontSize:'12px', color: '#7A7A7A'}}>₩</span><span style={{color: '#7A7A7A'}}>{formatLocalString(detailData?.deposit_price || 0)}</span>
                  </div>
                  <div className="detail_insurance">
                    {t('peace_of_mind_insurance')}: <span style={{color: '#7A7A7A'}}>{detailData?.insurance_flag === "Y" ? t('possible_to_join') : t('impossible_to_join')}</span>
                  </div>
                </div>


                <div className="price_detail_txt">{t('all_price_is_vat_included')}</div>
                {detailData?.discount_rate > 0 && (
                  <div className="border-prod_price">{detailData?.discount_rate > 0 ? `${detailData?.discount_rate}` : ''}<span style={{fontSize:'11px'}}>%</span></div>
                )}
                {(detailData?.goods_type === 'package' || detailData?.goods_type === 'rental') && (
                  detailData?.group_label_flag === 'Y' ? (
                    <div className="day_all">
                      <div className="day half">
                        <div className="order_m_btn">
                          <span>{detailData?.group_label_txt}</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="day_all">
                      <div className="day half">
                        <div className="day_hour_price">
                          <span className="hour">12h </span>
                          <span className="price">
                            <span className="price_won">₩</span>
                            {detailData?.result_12_price ? formatLocalString(detailData?.result_12_price || '0') : ''} 
                          </span>
                        </div>
                        {detailData?.discount_rate > 0 && (
                          <div className="consumer_price">
                            <span className="consumer_price_won">₩</span>
                            <span className="line_through">{detailData?.rental_12_price ? formatLocalString(detailData?.basic_12_price || '0') : ''}</span>
                            {/* <span className="consumer_price_won" style={{ marginLeft: '8px' }}>inc VAT</span> */}
                          </div>
                        )}
                      </div>
                      <div className="day">
                        <div className="day_hour_price">
                          <span className="hour">24h</span>
                          <span className="price">
                            <span className="price_won">₩</span>
                            {detailData?.result_24_price ? formatLocalString(detailData?.result_24_price || '0') : ''} 
                          </span>
                        </div>
                        {detailData?.discount_rate > 0 && (
                        <div className="consumer_price">
                            <span className="consumer_price_won">₩</span>
                            <span className="line_through">{detailData?.rental_24_price ? formatLocalString(detailData?.basic_24_price || '0') : ''}</span>
                              {/* <span className="consumer_price_won" style={{ marginLeft: '8px' }}>inc VAT</span> */}
                            </div>
                        )}
                      </div>
                    </div>
                  )
                )}

                {detailData?.goods_type === 'sale' && (
                  <div className="day_all">
                    <div className="day half sale">
                      <div className="day_hour_price">
                          <span className="price">
                              <span className="price_won">₩</span>
                              {detailData?.price ? formatLocalString(detailData?.price || '0') : ''}
                          </span>
                      </div>
                      {detailData?.discount_rate > 0 && (
                        <div className="consumer_price">
                          <span className="consumer_price_won">₩</span>
                          <span className="line_through">{detailData?.unit_price ? formatLocalString(detailData?.unit_price || '0') : ''}</span>
                          <span 
                            className="consumer_price_won" 
                            style={{marginLeft:'4px'}}
                          >inc VAT
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {detailData?.goods_type !== 'sale' && (
              <div className="calendar-wrapper" style={{ width: '100%', maxWidth: '100%' }}>
                <Calendar 
                  stockCalendar={stockCalendar} 
                  onMonthChange={handleMonthChange}
                />
              </div>
            )}

            {detailData?.goods_type === 'package' && (
              <div>
                <div className="package_con overflow_visible" style={{position:'relative', zIndex: 99}}>
                  <div className="pack_top">
                    <div className="pack_title">
                      <h3>{t('package_product')}</h3>
                      <p>{selectedPackages.length}<span>/{packTotal}</span></p>
                    </div>
                    <p style={{fontSize:'12px', color:'#333'}}>{detailData?.package_view_name}</p>
                    <p style={{fontSize:'12px'}}>{t('package_reselection_txt')}</p>
                  </div>

                  <div className="pack_swiper_container" style={{position:'relative', zIndex: 1000}}>
                    <Swiper 
                      {...packageSwiperOptions}
                      modules={[Grid, Pagination, Navigation]}
                      className="package-swiper"
                      onSlideChange={(swiper) => {
                        // 마지막 슬라이드에 도달하면 다음 페이지 데이터 로드
                        if (swiper.isEnd && packageGoods.length < packTotal) {
                          setCurrentPage(prev => prev + 1);
                        }
                      }}
                    >
                      {Array(Math.ceil(packageGoods.length / 8)).fill().map((_, index) => (
                        <SwiperSlide key={index} style={{ overflow: 'visible' }}>
                          <PackageList 
                            startIndex={index * 8}
                            onHover={setHoveredPackIndex}
                            packageItems={packageGoods.slice(index * 8, (index + 1) * 8)}
                            selectedIndexes={selectedPackages}
                            onSelect={(index) => {
                              handleReSelectPackage();
                            }}
                          />
                        </SwiperSlide>
                      ))}
                      <div className="swiper-pagination"></div>
                    </Swiper>
                  </div>

                  {hoveredPackIndex !== null && packageGoods[hoveredPackIndex] && (
                    <div 
                      className="price_bubble"
                      style={{
                        position: 'absolute',
                        // top: `${Math.floor((hoveredPackIndex % 8) / 4) === 0 ? '5px' : '70px'}`,
                        // left: `${(hoveredPackIndex % 4) * 183 + 90}px`,
                        // transform: 'translateX(-50%)',
                        ...bubblePosition,
                        marginBottom: '8px',
                        zIndex: 99999
                      }}
                    >
                      <div className="day half">
                        <div className="day_hour_price">
                          <span className="hour">12h</span>
                          <span className="price">
                            <span className="price_won">₩</span>
                            {packageGoods[hoveredPackIndex].result_12_price ?formatLocalString(packageGoods[hoveredPackIndex].result_12_price || 0): ''}
                          </span>
                        </div>
                        <div className="consumer_price">
                          <span className="consumer_price_won">₩</span>
                          <span className="line_through">
                            {packageGoods[hoveredPackIndex].rental_12_price ? formatLocalString(packageGoods[hoveredPackIndex].rental_12_price || 0) : ''}
                          </span>
                        </div>
                      </div>
                      <div className="day">
                        <div className="day_hour_price">
                          <span className="hour">24h</span>
                          <span className="price">
                            <span className="price_won">₩</span>
                            {packageGoods[hoveredPackIndex].result_24_price ? formatLocalString(packageGoods[hoveredPackIndex].result_24_price || 0) : ''}
                          </span>
                        </div>
                        <div className="consumer_price">
                          <span className="consumer_price_won">₩</span>
                          <span className="line_through">
                            {packageGoods[hoveredPackIndex].rental_24_price ? formatLocalString(packageGoods[hoveredPackIndex].rental_24_price || 0) : ''}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 좋아요, 장바구니 버튼 */}
            {detailData?.goods_type === 'package' && (
              <div>
                <div className="flex-center-4 m_fix_btm">
                  <button 
                    type="button" 
                    className="detail_wish_box" 
                    onClick={handleWish}
                  >
                    <div className={`detail_wish_btn ${isWish ? 'active' : ''}`}></div>
                    <span>{detailData?.like_count || 0}</span>
                  </button>

                  <div className="detail_btn_wide">
                      <button 
                        type="button"
                        className="detail_pack_select"
                        onClick={handleReSelectPackage}
                      >
                        {t('package_reselection')}
                      </button>

                      <button 
                        type="button"
                        className="default_btn yellow"
                        onClick={addCartProduct}
                        >
                        {t('shopping_cart')}
                      </button>
                  </div>
                </div>
              </div>
            )}

            {(detailData?.goods_type === 'rental' || detailData?.goods_type === 'sale' ) && (
              <div>
                <div className="flex-center-4 m_fix_btm">
                  <div className="detail_btn_wide">
                    <button 
                      type="button" 
                      className="detail_wish_box" 
                      onClick={handleWish}
                    >
                      <div className={`detail_wish_btn ${isWish ? 'active' : ''}`}></div>
                      <span>{detailData?.like_count || 0}</span>
                    </button>

                    <button 
                      type="button"
                      className="default_btn yellow"
                      onClick={addCartProduct}
                      >
                      {t('shopping_cart')}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

        {detailData?.bannerList && !Array.isArray(detailData?.bannerList) && (
          <section className="detail_banner">
            <div 
              style={{ cursor: detailData?.bannerList?.link_url ? 'pointer' : 'default' }}
              onClick={() => {
                if (detailData?.bannerList?.link_url) {
                  if (detailData?.bannerList?.target_type === 'blank') {
                    window.open(detailData?.bannerList?.link_url, '_blank');
                  } else {
                    window.location.href = detailData?.bannerList?.link_url;
                  }
                }
              }}
            >
              <img 
                src={isTablet ? detailData?.bannerList?.mobile_img : detailData?.bannerList?.pc_img} 
                alt="bannerImg" 
                loading="lazy"
              />
            </div>
          </section>
        )}

      {/* 관련상품 */}
      {relatedGoods.length > 0 && (
      <section className="detail_pro_slide">
        <h3><span className="d_yellow_text">{t('related_product')}</span> {t('product_txt')}</h3>
        <div className="p0">
          <ProductSection
            products={relatedGoods}
            swiperOptions={sectionSwiperOptions}
            showTabs={false}
            showMoreButton={false}
          />
        </div>
      </section>
    )}

      <section className="detail_desc">
        <div>
          <div className="prod_desc_tab">
            <ul>
              <li>
                <button 
                  type="button"
                  className={`desc_btn ${activeTab === 'outline' ? 'active' : ''}`}
                  onClick={() => handleTabActive('outline')}
                >
                  {t('product_overview')}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className={`desc_btn ${activeTab === 'detail' ? 'active' : ''}`}
                  onClick={() => handleTabActive('detail')}
                >
                  {t('product_details')}
                </button>
              </li>              
              <li>
                <button
                  type="button"
                  className={`desc_btn ${activeTab === 'spec' ? 'active' : ''}`}
                  onClick={() => handleTabActive('spec')}
                >
                  {t('product_specifications')}
                </button>
              </li>
            </ul>
          </div>

          {activeTab === 'outline' && (
            <div className="prod_outline">
              {detailData?.goods_type !== 'sale' && detailData?.daily_sale_display === 'Y' && (
              <div className="mx_1126">
                <div className="column flex-8">
                  <h3><span className="d_yellow_text">Rental</span> Price</h3>
                  <p>{t('rental_time_discount_txt')}</p>
                </div>

                <div>
                  <ul className={`rental_schedule ${!isScheduleOpen ? 'schedule_closed' : ''}`}>
                    {detailData?.dailyPriceList.map((rental, idx) => (
                      <li key={idx} className="rental_item">
                        <span className="rental_time">{rental.label}</span>
                        <span className="rental_price">
                          ₩{rental.price.toLocaleString()}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div className="schedule_open">
                    <button
                      type="button"
                      className="default_btn yellow"
                      onClick={() => setIsScheduleOpen(!isScheduleOpen)}
                    >
                      {isScheduleOpen ? t('close') : t('open')}
                    </button>
                  </div>
                </div>
              </div>
              )}


              {/* video_url_01 데이터가 없으면 안보이게 분기 */}
              {/* {detailData?.video_url_01 && ( */}
                <div className="mx_1126">
                  <h3><span className="d_yellow_text">{t('product_overview_txt')}</span> {t('product_details_txt')}</h3>
                  <div className="detail_img_section">
                    {(convertYouTubeUrl(detailData?.video_url_01) || detailData?.goods_overview) ? (
                      <>
                        {convertYouTubeUrl(detailData?.video_url_01) && (
                          <div className="video_box">
                            <iframe
                              width="100%"
                              height="315"
                              src={convertYouTubeUrl(detailData?.video_url_01)}
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )}
                        {convertYouTubeUrl(detailData?.video_url_02) && (
                          <div className="video_box">
                            <iframe
                              width="100%"
                              height="315"
                              src={convertYouTubeUrl(detailData?.video_url_02)}
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )}
                        {convertYouTubeUrl(detailData?.video_url_03) && (
                          <div className="video_box">
                            <iframe
                              width="100%"
                              height="315"
                              src={convertYouTubeUrl(detailData?.video_url_03)}
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen
                            ></iframe>
                          </div>
                        )}
                        {detailData?.goods_overview && (
                          <div>
                            <div dangerouslySetInnerHTML={{ __html: detailData.goods_overview }} />
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="no_result-1">
                        <p>{t('product_specifications_txt')}</p>
                      </div>
                    )}
                  </div>
                </div>
              {/* )} */}
            </div>
          )}

          {activeTab === 'detail' && (
            <div className="prod_detail">
              <div className="mx_1126">
                <h3><span className="d_yellow_text">{t('product_overview_txt')}</span> {t('product_specifications_empty')}</h3>
                <div className="detail_img_section">
                    {detailData?.goods_features.length > 0 ? (
                      <div dangerouslySetInnerHTML={{ __html: detailData?.goods_features || '' }} />
                    ) : (
                      <div className="no_result-1">
                        <p>{t('product_specifications_txt')}</p>  
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'spec' && (
            <div className="prod_spec">
                <div className="mx_1126">
                    <h3><span className="d_yellow_text">{t('product_overview_txt')}</span> {t('product_specifications_empty2')}</h3>
                    <div>
                        {detailData?.specList && detailData.specList.length > 0 ? (
                            <ul className="detail_spec">
                                {detailData.specList.map((spec, idx) => (
                                    <li key={idx}>
                                        <p className="spec_bold">{spec.spec_title}</p>
                                        <p className="spec_light">
                                            <span dangerouslySetInnerHTML={{ __html: spec.spec_desc }} />
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="no_result-1" style={{marginTop: '32px'}}>
                                <p>{t('product_specifications_empty3')}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
          )}
        </div>
      </section>

      {/* 추천상품 */}
      {recommendGoods.length > 0 && (
      <section className="detail_recom_slide">
        <h3><span className="d_yellow_text">{t('recommended_product')}</span> {t('product_specifications_empty4')}</h3>
        <div className="p0">
          {recommendGoods.length > 0 ? (
            <ProductSection
              products={recommendGoods}
              swiperOptions={sectionSwiperOptions}
              showTabs={false}
              showMoreButton={false}
            />
          ) : (
            <div className="no_result-1">
              <p>{t('product_specifications_empty5')}</p>
            </div>
          )}
        </div>
      </section>
      )}


      {/* 데이페이 이용 이유 */}
      <section style={{maxWidth: '1404px', margin: '0 auto', padding: ' 40px 16px'}}>
        <div className="reason_container">
          <h3 className="commu_title noline">{t('daypay_reason')}</h3>
          <div className="reason_inner">
            <ul className="reason_con">
              {instructionData.map((item, index) => (
                <li key={index}>
                  <img src={item.icon_image_url} alt="cart" loading="lazy"/>
                  <div className="reason_txt">
                    <p>{item.subject}</p>
                    <span className="g-90">
                      {item.content}
                  </span>
                </div>
                {item.btn_link_url && (
                <button
                  type="button"
                  className="reason_btn"
                  onClick={() => {
                    if (item.btn_link_url.startsWith('http')) {
                      window.open(item.btn_link_url, '_blank');
                    } else {
                      navigate(item.btn_link_url);
                    }
                  }}
                >
                  {item.btn_link_name}
                  </button>
                )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>


      {/* 장바구니 확인 팝업 */}
      <CartConfirmPopup 
        isPopup={isPopupCart} 
        setIsPopup={setPopupCart}
        goods_seq={goods_seq}
        orderMethod={state.method === 'visit' || state.method === 'parcel' ? state.method : detailData?.goods_type}
        navigation={navigation}
      />

      {/* 패키지 재선택 팝업 */}
      <PackageReSelectPopup 
        isPopup={isPopupReSelect.isOpen} 
        setIsPopup={(value) => setPopupReSelect(prev => ({ ...prev, isOpen: value }))}
        packageData={isPopupReSelect.packageData}
        selectedProductSeqs={selectedProductSeqs}
        onSelectComplete={(newSelectedProductSeqs, selectedProductInfo) => {
          
          // product_seq 기반으로 기본 화면의 인덱스 찾기
          const newSelectedIndexes = packageGoods
            .map((item, index) => newSelectedProductSeqs.includes(item.product_seq) ? index : null)
            .filter(index => index !== null);
          
          setSelectedPackages(newSelectedIndexes);
          setSelectedProductSeqs(newSelectedProductSeqs);
          setSelectedProductInfo(selectedProductInfo);
          setPopupReSelect(prev => ({ ...prev, isOpen: false }));
        }}
        totalCnt={isPopupReSelect.totalCnt}
      />

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
    />

      {/* 구성품 팝업 */}
      <ComponentViewPopup 
        isPopup={isComponentPopup} 
        setIsPopup={setIsComponentPopup}
        componentData={componentTotal}
      />

    </div>
  );
}

export default PackageDetail;